import { createContext } from 'react';

export const UserContext = createContext({});

export const UserProvider = ({ children, user, agencyClient, setAgencyClient, isPro, isAgencyClientRetrieved }) => {
  const isLoggedIn = !!user?.id;
  return (
    <UserContext.Provider
      value={{
        user,
        isPro,
        isLoggedIn,
        agencyClient,
        setAgencyClient,
        isAgencyClientRetrieved
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
